import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

window.Office.initialize = () => {
  new Vue({
    render: h => h(App),
    store
  }).$mount('#app');

  window.Office.context.ui.addHandlerAsync(
    window.Office.EventType.DialogParentMessageReceived,
    event => {
      try {
        store.dispatch('update', JSON.parse(event.message));
      } catch (e) {
        window.Office.context.ui.messageParent(JSON.stringify({ action: 'exception', data: e }));
      }
    },
    asyncResult => {
      if (asyncResult.status !== Office.AsyncResultStatus.Succeeded) {
        window.Office.context.ui.messageParent(JSON.stringify({ action: 'exception', data: asyncResult.error }));
      } else {
        window.Office.context.ui.messageParent(JSON.stringify({ action: 'ready' }));
      }
    }
  );
};
